// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { AuthenticateWithGoogleData, AuthenticateWithGoogleErrors, AuthenticateWithGoogleResponses, BulkCreateCollectionModelsData, BulkCreateCollectionModelsErrors, BulkCreateCollectionModelsResponses, BulkDeleteCollectionModelsData, BulkDeleteCollectionModelsErrors, BulkDeleteCollectionModelsResponses, BulkUpdateUserRolesData, BulkUpdateUserRolesErrors, BulkUpdateUserRolesResponses, CreateArmyCollectionData, CreateArmyCollectionResponses, CreateCollectionModelData, CreateCollectionModelErrors, CreateCollectionModelImageUploadUrlData, CreateCollectionModelImageUploadUrlErrors, CreateCollectionModelImageUploadUrlResponses, CreateCollectionModelResponses, CreateFactionData, CreateFactionErrors, CreateFactionResponses, CreateModelDefinitionDraftData, CreateModelDefinitionDraftErrors, CreateModelDefinitionDraftResponses, CreateMyFactionData, CreateMyFactionErrors, CreateMyFactionResponses, CreateMyModelDefinitionData, CreateMyModelDefinitionResponses, CreateMyPaintData, CreateMyPaintErrors, CreateMyPaintResponses, CreateMyWargearDefinitionData, CreateMyWargearDefinitionErrors, CreateMyWargearDefinitionResponses, CreatePaintData, CreatePaintErrors, CreatePaintResponses, CustomiseFactionData, CustomiseFactionErrors, CustomiseFactionResponses, CustomiseModelDefinitionData, CustomiseModelDefinitionErrors, CustomiseModelDefinitionResponses, CustomisePaintData, CustomisePaintErrors, CustomisePaintResponses, CustomiseWargearDefinitionData, CustomiseWargearDefinitionErrors, CustomiseWargearDefinitionResponses, DeleteArmyCollectionData, DeleteArmyCollectionErrors, DeleteArmyCollectionResponses, DeleteCollectionModelData, DeleteCollectionModelErrors, DeleteCollectionModelImageData, DeleteCollectionModelImageErrors, DeleteCollectionModelImageResponses, DeleteCollectionModelResponses, DeleteCollectionModelStatusEventData, DeleteCollectionModelStatusEventErrors, DeleteCollectionModelStatusEventResponses, DeleteFactionData, DeleteFactionErrors, DeleteFactionResponses, DeleteModelDefinitionData, DeleteModelDefinitionErrors, DeleteModelDefinitionResponses, DeleteMyFactionData, DeleteMyFactionErrors, DeleteMyFactionResponses, DeleteMyModelDefinitionData, DeleteMyModelDefinitionErrors, DeleteMyModelDefinitionResponses, DeleteMyPaintData, DeleteMyPaintErrors, DeleteMyPaintResponses, DeleteMyWargearDefinitionData, DeleteMyWargearDefinitionErrors, DeleteMyWargearDefinitionResponses, DeletePaintData, DeletePaintErrors, DeletePaintResponses, DiscardFactionDraftData, DiscardFactionDraftErrors, DiscardFactionDraftResponses, DiscardModelDefinitionDraftData, DiscardModelDefinitionDraftErrors, DiscardModelDefinitionDraftResponses, DiscardPaintDraftData, DiscardPaintDraftErrors, DiscardPaintDraftResponses, DiscardWargearDefinitionDraftData, DiscardWargearDefinitionDraftErrors, DiscardWargearDefinitionDraftResponses, ExportFactionsData, ExportFactionsErrors, ExportFactionsResponses, ExportModelDefinitionsData, ExportModelDefinitionsErrors, ExportModelDefinitionsResponses, ExportPaintsData, ExportPaintsErrors, ExportPaintsResponses, ExportWargearDefinitionsData, ExportWargearDefinitionsErrors, ExportWargearDefinitionsResponses, GetAdminModelDefinitionsData, GetAdminModelDefinitionsErrors, GetAdminModelDefinitionsResponses, GetAdminPaintsData, GetAdminPaintsErrors, GetAdminPaintsResponses, GetArmyCollectionData, GetArmyCollectionErrors, GetArmyCollectionResponses, GetArmyCollectionsData, GetArmyCollectionsResponses, GetAvailableWargearDefinitionsData, GetAvailableWargearDefinitionsResponses, GetCollectionModelsData, GetCollectionModelsErrors, GetCollectionModelsResponses, GetCurrentUserData, GetCurrentUserErrors, GetCurrentUserResponses, GetFactionDraftsData, GetFactionDraftsErrors, GetFactionDraftsResponses, GetFactionPublishHistoryData, GetFactionPublishHistoryErrors, GetFactionPublishHistoryResponses, GetFactionsData, GetFactionsErrors, GetFactionsListData, GetFactionsListResponses, GetFactionsResponses, GetModelDefinitionDraftData, GetModelDefinitionDraftErrors, GetModelDefinitionDraftResponses, GetModelDefinitionDraftsData, GetModelDefinitionDraftsErrors, GetModelDefinitionDraftsResponses, GetModelDefinitionPublishHistoryData, GetModelDefinitionPublishHistoryErrors, GetModelDefinitionPublishHistoryResponses, GetModelDefinitionsData, GetModelDefinitionsResponses, GetMyFactionsData, GetMyFactionsResponses, GetMyModelDefinitionsData, GetMyModelDefinitionsResponses, GetMyPaintsData, GetMyPaintsResponses, GetMyWargearDefinitionsData, GetMyWargearDefinitionsResponses, GetPaintDraftsData, GetPaintDraftsErrors, GetPaintDraftsResponses, GetPaintPublishHistoryData, GetPaintPublishHistoryErrors, GetPaintPublishHistoryResponses, GetPaintRecipesData, GetPaintRecipesErrors, GetPaintRecipesResponses, GetPaintsData, GetPaintsResponses, GetPublicArmyCollectionsData, GetPublicArmyCollectionsResponses, GetSharedFactionsData, GetSharedFactionsResponses, GetSharedModelDefinitionsData, GetSharedModelDefinitionsResponses, GetSharedPaintsData, GetSharedPaintsResponses, GetSharedWargearDefinitionsData, GetSharedWargearDefinitionsResponses, GetUsersData, GetUsersErrors, GetUsersResponses, GetWargearDefinitionDraftsData, GetWargearDefinitionDraftsErrors, GetWargearDefinitionDraftsResponses, GetWargearDefinitionsData, GetWargearDefinitionsErrors, GetWargearDefinitionsResponses, GetWargearPublishHistoryData, GetWargearPublishHistoryErrors, GetWargearPublishHistoryResponses, ImportFactionsData, ImportFactionsErrors, ImportFactionsResponses, ImportModelDefinitionsData, ImportModelDefinitionsErrors, ImportModelDefinitionsResponses, ImportPaintsData, ImportPaintsErrors, ImportPaintsResponses, ImportWargearDefinitionsData, ImportWargearDefinitionsErrors, ImportWargearDefinitionsResponses, PreviewModelDefinitionChangeData, PreviewModelDefinitionChangeErrors, PreviewModelDefinitionChangeResponses, ProposeFactionChangeData, ProposeFactionChangeErrors, ProposeFactionChangeResponses, ProposePaintChangeData, ProposePaintChangeErrors, ProposePaintChangeResponses, PublishFactionDraftData, PublishFactionDraftErrors, PublishFactionDraftResponses, PublishModelDefinitionDraftData, PublishModelDefinitionDraftErrors, PublishModelDefinitionDraftResponses, PublishPaintDraftData, PublishPaintDraftErrors, PublishPaintDraftResponses, PublishWargearDefinitionDraftData, PublishWargearDefinitionDraftErrors, PublishWargearDefinitionDraftResponses, RecordCollectionModelStatusEventData, RecordCollectionModelStatusEventErrors, RecordCollectionModelStatusEventResponses, ReorderArmyCollectionsData, ReorderArmyCollectionsErrors, ReorderArmyCollectionsResponses, ReorderModelDefinitionGroupsData, ReorderModelDefinitionGroupsErrors, ReorderModelDefinitionGroupsResponses, SavePaintRecipeData, SavePaintRecipeErrors, SavePaintRecipeResponses, SetCollectionModelListThumbnailData, SetCollectionModelListThumbnailErrors, SetCollectionModelListThumbnailResponses, SetDefinitionsHiddenData, SetDefinitionsHiddenErrors, SetDefinitionsHiddenResponses, StartModelDefinitionDraftData, StartModelDefinitionDraftErrors, StartModelDefinitionDraftResponses, UpdateArmyCollectionData, UpdateArmyCollectionErrors, UpdateArmyCollectionResponses, UpdateCollectionModelData, UpdateCollectionModelErrors, UpdateCollectionModelResponses, UpdateModelDefinitionDraftData, UpdateModelDefinitionDraftErrors, UpdateModelDefinitionDraftResponses, UpdateMyFactionData, UpdateMyFactionErrors, UpdateMyFactionResponses, UpdateMyModelDefinitionData, UpdateMyModelDefinitionErrors, UpdateMyModelDefinitionResponses, UpdateMyPaintData, UpdateMyPaintErrors, UpdateMyPaintResponses, UpdateMyThemePreferenceData, UpdateMyThemePreferenceErrors, UpdateMyThemePreferenceResponses, UpdateMyWargearDefinitionData, UpdateMyWargearDefinitionErrors, UpdateMyWargearDefinitionResponses, UpdateUserRoleData, UpdateUserRoleErrors, UpdateUserRoleResponses, UpdateWargearDefinitionData, UpdateWargearDefinitionErrors, UpdateWargearDefinitionResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Authenticate with a Google ID token
 */
export const authenticateWithGoogle = <ThrowOnError extends boolean = false>(options: Options<AuthenticateWithGoogleData, ThrowOnError>): RequestResult<AuthenticateWithGoogleResponses, AuthenticateWithGoogleErrors, ThrowOnError> => (options.client ?? client).post<AuthenticateWithGoogleResponses, AuthenticateWithGoogleErrors, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/auth/google',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current authenticated user
 */
export const getCurrentUser = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserData, ThrowOnError>): RequestResult<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentUserResponses, GetCurrentUserErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me',
    ...options
});

/**
 * Update the current authenticated user's theme preference
 */
export const updateMyThemePreference = <ThrowOnError extends boolean = false>(options: Options<UpdateMyThemePreferenceData, ThrowOnError>): RequestResult<UpdateMyThemePreferenceResponses, UpdateMyThemePreferenceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateMyThemePreferenceResponses, UpdateMyThemePreferenceErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/me/theme-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all users (admin only)
 */
export const getUsers = <ThrowOnError extends boolean = false>(options?: Options<GetUsersData, ThrowOnError>): RequestResult<GetUsersResponses, GetUsersErrors, ThrowOnError> => (options?.client ?? client).get<GetUsersResponses, GetUsersErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users',
    ...options
});

/**
 * Update another user's role (admin only)
 */
export const updateUserRole = <ThrowOnError extends boolean = false>(options: Options<UpdateUserRoleData, ThrowOnError>): RequestResult<UpdateUserRoleResponses, UpdateUserRoleErrors, ThrowOnError> => (options.client ?? client).patch<UpdateUserRoleResponses, UpdateUserRoleErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/{userId}/role',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update multiple users' roles at once (admin only)
 */
export const bulkUpdateUserRoles = <ThrowOnError extends boolean = false>(options: Options<BulkUpdateUserRolesData, ThrowOnError>): RequestResult<BulkUpdateUserRolesResponses, BulkUpdateUserRolesErrors, ThrowOnError> => (options.client ?? client).patch<BulkUpdateUserRolesResponses, BulkUpdateUserRolesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/users/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all army collections
 */
export const getArmyCollections = <ThrowOnError extends boolean = false>(options?: Options<GetArmyCollectionsData, ThrowOnError>): RequestResult<GetArmyCollectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetArmyCollectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections',
    ...options
});

/**
 * Create a new army collection
 */
export const createArmyCollection = <ThrowOnError extends boolean = false>(options: Options<CreateArmyCollectionData, ThrowOnError>): RequestResult<CreateArmyCollectionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateArmyCollectionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all public army collections
 */
export const getPublicArmyCollections = <ThrowOnError extends boolean = false>(options?: Options<GetPublicArmyCollectionsData, ThrowOnError>): RequestResult<GetPublicArmyCollectionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPublicArmyCollectionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/public',
    ...options
});

/**
 * Reorder the current user's army collections (drag-to-reorder on the Collections page)
 */
export const reorderArmyCollections = <ThrowOnError extends boolean = false>(options: Options<ReorderArmyCollectionsData, ThrowOnError>): RequestResult<ReorderArmyCollectionsResponses, ReorderArmyCollectionsErrors, ThrowOnError> => (options.client ?? client).patch<ReorderArmyCollectionsResponses, ReorderArmyCollectionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an army collection (and its models, images, and paint recipes)
 */
export const deleteArmyCollection = <ThrowOnError extends boolean = false>(options: Options<DeleteArmyCollectionData, ThrowOnError>): RequestResult<DeleteArmyCollectionResponses, DeleteArmyCollectionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteArmyCollectionResponses, DeleteArmyCollectionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}',
    ...options
});

/**
 * Get a single army collection
 */
export const getArmyCollection = <ThrowOnError extends boolean = false>(options: Options<GetArmyCollectionData, ThrowOnError>): RequestResult<GetArmyCollectionResponses, GetArmyCollectionErrors, ThrowOnError> => (options.client ?? client).get<GetArmyCollectionResponses, GetArmyCollectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}',
    ...options
});

/**
 * Rename/update an army collection
 */
export const updateArmyCollection = <ThrowOnError extends boolean = false>(options: Options<UpdateArmyCollectionData, ThrowOnError>): RequestResult<UpdateArmyCollectionResponses, UpdateArmyCollectionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateArmyCollectionResponses, UpdateArmyCollectionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reorder the model-definition groups (accordion sections) shown within an army collection's model list
 */
export const reorderModelDefinitionGroups = <ThrowOnError extends boolean = false>(options: Options<ReorderModelDefinitionGroupsData, ThrowOnError>): RequestResult<ReorderModelDefinitionGroupsResponses, ReorderModelDefinitionGroupsErrors, ThrowOnError> => (options.client ?? client).patch<ReorderModelDefinitionGroupsResponses, ReorderModelDefinitionGroupsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/model-definition-order',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all available model types (e.g. Poxwalker)
 *
 * Open to anonymous callers for preview mode. When a bearer token is present, any shared definition the user has customised is replaced by their own version and their from-scratch definitions are included, so this is the catalogue as that user sees it.
 */
export const getModelDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetModelDefinitionsData, ThrowOnError>): RequestResult<GetModelDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetModelDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/model-definitions',
    ...options
});

/**
 * List the wargear the signed-in user can attach to a personal model definition
 *
 * The shared catalogue plus any wargear this user created for their own definitions.
 */
export const getAvailableWargearDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetAvailableWargearDefinitionsData, ThrowOnError>): RequestResult<GetAvailableWargearDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAvailableWargearDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/wargear-definitions',
    ...options
});

/**
 * List the signed-in user's own model definitions
 *
 * Both kinds of personal definition: customisations of a shared definition (which carry a baseModelDefinitionId) and ones the user wrote from scratch (which do not).
 */
export const getMyModelDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetMyModelDefinitionsData, ThrowOnError>): RequestResult<GetMyModelDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyModelDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions',
    ...options
});

/**
 * Create a model definition of the user's own
 */
export const createMyModelDefinition = <ThrowOnError extends boolean = false>(options: Options<CreateMyModelDefinitionData, ThrowOnError>): RequestResult<CreateMyModelDefinitionResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateMyModelDefinitionResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared catalogue without the signed-in user's customisations
 *
 * GET /api/v1/model-definitions returns the shared catalogue and the user's own definitions together, so a customisation appears alongside the definition it was forked from. This endpoint returns the shared definitions on their own: to offer them for customisation, and to diff a personal copy against the definition it came from.
 */
export const getSharedModelDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetSharedModelDefinitionsData, ThrowOnError>): RequestResult<GetSharedModelDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSharedModelDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions/shared',
    ...options
});

/**
 * Delete one of the user's own model definitions, reverting to the shared one if it was a customisation
 */
export const deleteMyModelDefinition = <ThrowOnError extends boolean = false>(options: Options<DeleteMyModelDefinitionData, ThrowOnError>): RequestResult<DeleteMyModelDefinitionResponses, DeleteMyModelDefinitionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMyModelDefinitionResponses, DeleteMyModelDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions/{modelDefinitionId}',
    ...options
});

/**
 * Replace the full contents of one of the user's own model definitions
 */
export const updateMyModelDefinition = <ThrowOnError extends boolean = false>(options: Options<UpdateMyModelDefinitionData, ThrowOnError>): RequestResult<UpdateMyModelDefinitionResponses, UpdateMyModelDefinitionErrors, ThrowOnError> => (options.client ?? client).put<UpdateMyModelDefinitionResponses, UpdateMyModelDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions/{modelDefinitionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start customising a shared model definition
 *
 * Copies the shared definition, its slots and its wargear options into a personal definition owned by the caller, which is then listed alongside the original wherever they see the catalogue. Idempotent - returns the existing customisation if they already have one.
 */
export const customiseModelDefinition = <ThrowOnError extends boolean = false>(options: Options<CustomiseModelDefinitionData, ThrowOnError>): RequestResult<CustomiseModelDefinitionResponses, CustomiseModelDefinitionErrors, ThrowOnError> => (options.client ?? client).post<CustomiseModelDefinitionResponses, CustomiseModelDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/model-definitions/from/{modelDefinitionId}',
    ...options
});

/**
 * List the signed-in user's own factions
 *
 * Both kinds of personal faction: customisations of a shared faction (which carry a baseFactionId) and ones the user created from scratch (which do not).
 */
export const getMyFactions = <ThrowOnError extends boolean = false>(options?: Options<GetMyFactionsData, ThrowOnError>): RequestResult<GetMyFactionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyFactionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions',
    ...options
});

/**
 * Create a faction of the user's own
 */
export const createMyFaction = <ThrowOnError extends boolean = false>(options: Options<CreateMyFactionData, ThrowOnError>): RequestResult<CreateMyFactionResponses, CreateMyFactionErrors, ThrowOnError> => (options.client ?? client).post<CreateMyFactionResponses, CreateMyFactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared factions on their own
 *
 * GET /api/v1/factions returns the shared factions and the user's own together. This endpoint returns the shared ones alone: to offer them for customisation, and to diff a personal copy against the faction it was forked from.
 */
export const getSharedFactions = <ThrowOnError extends boolean = false>(options?: Options<GetSharedFactionsData, ThrowOnError>): RequestResult<GetSharedFactionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSharedFactionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions/shared',
    ...options
});

/**
 * Delete one of the user's own factions, reverting to the shared one if it was a customisation
 */
export const deleteMyFaction = <ThrowOnError extends boolean = false>(options: Options<DeleteMyFactionData, ThrowOnError>): RequestResult<DeleteMyFactionResponses, DeleteMyFactionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMyFactionResponses, DeleteMyFactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions/{factionId}',
    ...options
});

/**
 * Update one of the user's own factions
 */
export const updateMyFaction = <ThrowOnError extends boolean = false>(options: Options<UpdateMyFactionData, ThrowOnError>): RequestResult<UpdateMyFactionResponses, UpdateMyFactionErrors, ThrowOnError> => (options.client ?? client).put<UpdateMyFactionResponses, UpdateMyFactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions/{factionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start customising a shared faction
 *
 * Copies the shared faction into one owned by the caller, which is then listed alongside the original. Idempotent - returns the existing customisation if they already have one.
 */
export const customiseFaction = <ThrowOnError extends boolean = false>(options: Options<CustomiseFactionData, ThrowOnError>): RequestResult<CustomiseFactionResponses, CustomiseFactionErrors, ThrowOnError> => (options.client ?? client).post<CustomiseFactionResponses, CustomiseFactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/factions/from/{factionId}',
    ...options
});

/**
 * List the signed-in user's own wargear
 *
 * Both kinds of personal wargear: customisations of shared wargear (which carry a baseWargearDefinitionId) and wargear the user named themselves, including anything created implicitly by naming wargear on a personal model definition.
 */
export const getMyWargearDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetMyWargearDefinitionsData, ThrowOnError>): RequestResult<GetMyWargearDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyWargearDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions',
    ...options
});

/**
 * Create wargear of the user's own
 */
export const createMyWargearDefinition = <ThrowOnError extends boolean = false>(options: Options<CreateMyWargearDefinitionData, ThrowOnError>): RequestResult<CreateMyWargearDefinitionResponses, CreateMyWargearDefinitionErrors, ThrowOnError> => (options.client ?? client).post<CreateMyWargearDefinitionResponses, CreateMyWargearDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared wargear on its own
 *
 * GET /api/v1/wargear-definitions returns the shared catalogue and the user's own together. This endpoint returns the shared wargear alone: to offer it for customisation, and to diff a personal copy against the wargear it was forked from.
 */
export const getSharedWargearDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetSharedWargearDefinitionsData, ThrowOnError>): RequestResult<GetSharedWargearDefinitionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSharedWargearDefinitionsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions/shared',
    ...options
});

/**
 * Delete one of the user's own wargear definitions
 */
export const deleteMyWargearDefinition = <ThrowOnError extends boolean = false>(options: Options<DeleteMyWargearDefinitionData, ThrowOnError>): RequestResult<DeleteMyWargearDefinitionResponses, DeleteMyWargearDefinitionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMyWargearDefinitionResponses, DeleteMyWargearDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions/{wargearDefinitionId}',
    ...options
});

/**
 * Rename one of the user's own wargear definitions
 */
export const updateMyWargearDefinition = <ThrowOnError extends boolean = false>(options: Options<UpdateMyWargearDefinitionData, ThrowOnError>): RequestResult<UpdateMyWargearDefinitionResponses, UpdateMyWargearDefinitionErrors, ThrowOnError> => (options.client ?? client).put<UpdateMyWargearDefinitionResponses, UpdateMyWargearDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions/{wargearDefinitionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start customising a shared wargear definition
 *
 * Copies the shared wargear into one owned by the caller, which they can then rename and attach to their own model definitions. Idempotent - returns the existing customisation if they already have one.
 */
export const customiseWargearDefinition = <ThrowOnError extends boolean = false>(options: Options<CustomiseWargearDefinitionData, ThrowOnError>): RequestResult<CustomiseWargearDefinitionResponses, CustomiseWargearDefinitionErrors, ThrowOnError> => (options.client ?? client).post<CustomiseWargearDefinitionResponses, CustomiseWargearDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/wargear-definitions/from/{wargearDefinitionId}',
    ...options
});

/**
 * List all factions. Used to group model types for browsing/selection - factions carry no army-building rules, purely catalogue organisation.
 */
export const getFactionsList = <ThrowOnError extends boolean = false>(options?: Options<GetFactionsListData, ThrowOnError>): RequestResult<GetFactionsListResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetFactionsListResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/factions',
    ...options
});

/**
 * List all factions (admin only). Used by admin tooling (e.g. to group model definitions by faction) - factions carry no army-building rules, purely catalogue organisation.
 */
export const getFactions = <ThrowOnError extends boolean = false>(options?: Options<GetFactionsData, ThrowOnError>): RequestResult<GetFactionsResponses, GetFactionsErrors, ThrowOnError> => (options?.client ?? client).get<GetFactionsResponses, GetFactionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions',
    ...options
});

/**
 * Create a new faction (admin only)
 */
export const createFaction = <ThrowOnError extends boolean = false>(options: Options<CreateFactionData, ThrowOnError>): RequestResult<CreateFactionResponses, CreateFactionErrors, ThrowOnError> => (options.client ?? client).post<CreateFactionResponses, CreateFactionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a faction (admin only)
 */
export const deleteFaction = <ThrowOnError extends boolean = false>(options: Options<DeleteFactionData, ThrowOnError>): RequestResult<DeleteFactionResponses, DeleteFactionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteFactionResponses, DeleteFactionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/{factionId}',
    ...options
});

/**
 * Propose a change to a faction (admin only). The change is staged for review rather than applied: a faction groups every model definition beneath it, so renaming or reparenting one is reviewed before it takes effect. Proposing the values already stored instead clears any pending change and returns 204.
 */
export const proposeFactionChange = <ThrowOnError extends boolean = false>(options: Options<ProposeFactionChangeData, ThrowOnError>): RequestResult<ProposeFactionChangeResponses, ProposeFactionChangeErrors, ThrowOnError> => (options.client ?? client).patch<ProposeFactionChangeResponses, ProposeFactionChangeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/{factionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List pending faction changes awaiting review (admin only), each showing the stored state and the proposed state.
 */
export const getFactionDrafts = <ThrowOnError extends boolean = false>(options?: Options<GetFactionDraftsData, ThrowOnError>): RequestResult<GetFactionDraftsResponses, GetFactionDraftsErrors, ThrowOnError> => (options?.client ?? client).get<GetFactionDraftsResponses, GetFactionDraftsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/drafts',
    ...options
});

/**
 * Accept a pending faction change (admin only), applying it and recording an audit entry.
 */
export const publishFactionDraft = <ThrowOnError extends boolean = false>(options: Options<PublishFactionDraftData, ThrowOnError>): RequestResult<PublishFactionDraftResponses, PublishFactionDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishFactionDraftResponses, PublishFactionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/drafts/{draftId}/publish',
    ...options
});

/**
 * Reject a pending faction change (admin only), keeping the stored state. A later import proposing the same change will raise it again.
 */
export const discardFactionDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardFactionDraftData, ThrowOnError>): RequestResult<DiscardFactionDraftResponses, DiscardFactionDraftErrors, ThrowOnError> => (options.client ?? client).delete<DiscardFactionDraftResponses, DiscardFactionDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/drafts/{draftId}',
    ...options
});

/**
 * Accepted changes to this faction, most recent first (admin only)
 */
export const getFactionPublishHistory = <ThrowOnError extends boolean = false>(options: Options<GetFactionPublishHistoryData, ThrowOnError>): RequestResult<GetFactionPublishHistoryResponses, GetFactionPublishHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetFactionPublishHistoryResponses, GetFactionPublishHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/{factionId}/publish-history',
    ...options
});

/**
 * Export all factions as a versioned JSON document (admin only)
 */
export const exportFactions = <ThrowOnError extends boolean = false>(options?: Options<ExportFactionsData, ThrowOnError>): RequestResult<ExportFactionsResponses, ExportFactionsErrors, ThrowOnError> => (options?.client ?? client).get<ExportFactionsResponses, ExportFactionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/export',
    ...options
});

/**
 * Import a versioned JSON document of factions (admin only). Factions are matched by stable source id. Factions the catalogue does not have are created outright; changes to existing ones are staged for review rather than applied, because a faction groups every model definition beneath it. Factions whose name and parent already match are left alone, so re-importing the same document reports nothing.
 */
export const importFactions = <ThrowOnError extends boolean = false>(options: Options<ImportFactionsData, ThrowOnError>): RequestResult<ImportFactionsResponses, ImportFactionsErrors, ThrowOnError> => (options.client ?? client).post<ImportFactionsResponses, ImportFactionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/factions/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all shared wargear definitions (admin only), each with how many published model definitions use it.
 */
export const getWargearDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetWargearDefinitionsData, ThrowOnError>): RequestResult<GetWargearDefinitionsResponses, GetWargearDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<GetWargearDefinitionsResponses, GetWargearDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions',
    ...options
});

/**
 * Propose a new name for a shared wargear definition (admin only). The rename is staged for review rather than applied, because one definition backs every model that carries the item, so a rename fans out across the catalogue. Proposing the name already stored instead clears any pending change and returns 204.
 */
export const updateWargearDefinition = <ThrowOnError extends boolean = false>(options: Options<UpdateWargearDefinitionData, ThrowOnError>): RequestResult<UpdateWargearDefinitionResponses, UpdateWargearDefinitionErrors, ThrowOnError> => (options.client ?? client).patch<UpdateWargearDefinitionResponses, UpdateWargearDefinitionErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/{wargearDefinitionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Accepted changes to this wargear definition, most recent first (admin only)
 */
export const getWargearPublishHistory = <ThrowOnError extends boolean = false>(options: Options<GetWargearPublishHistoryData, ThrowOnError>): RequestResult<GetWargearPublishHistoryResponses, GetWargearPublishHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetWargearPublishHistoryResponses, GetWargearPublishHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/{wargearDefinitionId}/publish-history',
    ...options
});

/**
 * List pending wargear name changes awaiting review (admin only), each showing the stored name and the name that would be applied. Proposals come from an import or from an admin's own edit.
 */
export const getWargearDefinitionDrafts = <ThrowOnError extends boolean = false>(options?: Options<GetWargearDefinitionDraftsData, ThrowOnError>): RequestResult<GetWargearDefinitionDraftsResponses, GetWargearDefinitionDraftsErrors, ThrowOnError> => (options?.client ?? client).get<GetWargearDefinitionDraftsResponses, GetWargearDefinitionDraftsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/drafts',
    ...options
});

/**
 * Accept a pending wargear name change (admin only), applying it to the shared definition and therefore to every model definition that uses it, and recording an audit entry.
 */
export const publishWargearDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<PublishWargearDefinitionDraftData, ThrowOnError>): RequestResult<PublishWargearDefinitionDraftResponses, PublishWargearDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishWargearDefinitionDraftResponses, PublishWargearDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/drafts/{draftId}/publish',
    ...options
});

/**
 * Reject a pending wargear name change (admin only), keeping the stored name. A later import proposing the same name will raise it again.
 */
export const discardWargearDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardWargearDefinitionDraftData, ThrowOnError>): RequestResult<DiscardWargearDefinitionDraftResponses, DiscardWargearDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).delete<DiscardWargearDefinitionDraftResponses, DiscardWargearDefinitionDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/drafts/{draftId}',
    ...options
});

/**
 * Export the whole shared wargear catalogue as a versioned JSON document (admin only), including entries no model definition currently uses.
 */
export const exportWargearDefinitions = <ThrowOnError extends boolean = false>(options?: Options<ExportWargearDefinitionsData, ThrowOnError>): RequestResult<ExportWargearDefinitionsResponses, ExportWargearDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<ExportWargearDefinitionsResponses, ExportWargearDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/export',
    ...options
});

/**
 * Import a versioned JSON document of wargear definitions (admin only), matched by stable source id. Wargear the catalogue does not have yet is created outright, but an entry whose name differs from the stored one raises a pending change for review rather than being renamed - one definition backs every model that carries the item, so an unattended rename fans out across the catalogue.
 */
export const importWargearDefinitions = <ThrowOnError extends boolean = false>(options: Options<ImportWargearDefinitionsData, ThrowOnError>): RequestResult<ImportWargearDefinitionsResponses, ImportWargearDefinitionsErrors, ThrowOnError> => (options.client ?? client).post<ImportWargearDefinitionsResponses, ImportWargearDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/wargear-definitions/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared model definition catalogue (admin only). Unlike GET /api/v1/model-definitions this never includes the caller's own personal definitions, which admins do not curate and whose factions are absent from the shared faction list this screen groups by. GET /api/v1/my/model-definitions/shared returns the same data but belongs to the personal-catalogue namespace.
 */
export const getAdminModelDefinitions = <ThrowOnError extends boolean = false>(options?: Options<GetAdminModelDefinitionsData, ThrowOnError>): RequestResult<GetAdminModelDefinitionsResponses, GetAdminModelDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminModelDefinitionsResponses, GetAdminModelDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions',
    ...options
});

/**
 * List all open model definition drafts (admin only)
 */
export const getModelDefinitionDrafts = <ThrowOnError extends boolean = false>(options?: Options<GetModelDefinitionDraftsData, ThrowOnError>): RequestResult<GetModelDefinitionDraftsResponses, GetModelDefinitionDraftsErrors, ThrowOnError> => (options?.client ?? client).get<GetModelDefinitionDraftsResponses, GetModelDefinitionDraftsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts',
    ...options
});

/**
 * Create a new, brand-new (not-yet-published) model definition draft (admin only)
 */
export const createModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<CreateModelDefinitionDraftData, ThrowOnError>): RequestResult<CreateModelDefinitionDraftResponses, CreateModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).post<CreateModelDefinitionDraftResponses, CreateModelDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start (or resume, if one is already open) editing a published model definition, seeding the draft from its current published state on first call (admin only)
 */
export const startModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<StartModelDefinitionDraftData, ThrowOnError>): RequestResult<StartModelDefinitionDraftResponses, StartModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).post<StartModelDefinitionDraftResponses, StartModelDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/{modelDefinitionId}/draft',
    ...options
});

/**
 * Permanently delete a published model definition, its attachment slots/wargear options, any open draft for it, and its publish history. Refused if any user's collection models still reference it (admin only)
 */
export const deleteModelDefinition = <ThrowOnError extends boolean = false>(options: Options<DeleteModelDefinitionData, ThrowOnError>): RequestResult<DeleteModelDefinitionResponses, DeleteModelDefinitionErrors, ThrowOnError> => (options.client ?? client).delete<DeleteModelDefinitionResponses, DeleteModelDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/{modelDefinitionId}',
    ...options
});

/**
 * Discard a draft without publishing it (admin only)
 */
export const discardModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardModelDefinitionDraftData, ThrowOnError>): RequestResult<DiscardModelDefinitionDraftResponses, DiscardModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).delete<DiscardModelDefinitionDraftResponses, DiscardModelDefinitionDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts/{draftId}',
    ...options
});

/**
 * Get a single draft (admin only)
 */
export const getModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<GetModelDefinitionDraftData, ThrowOnError>): RequestResult<GetModelDefinitionDraftResponses, GetModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).get<GetModelDefinitionDraftResponses, GetModelDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts/{draftId}',
    ...options
});

/**
 * Replace the full contents of a draft (admin only)
 */
export const updateModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<UpdateModelDefinitionDraftData, ThrowOnError>): RequestResult<UpdateModelDefinitionDraftResponses, UpdateModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).put<UpdateModelDefinitionDraftResponses, UpdateModelDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts/{draftId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish a draft, upserting its data onto the live model definition (creating one if this draft was not-yet-published) and recording an audit entry (admin only)
 */
export const publishModelDefinitionDraft = <ThrowOnError extends boolean = false>(options: Options<PublishModelDefinitionDraftData, ThrowOnError>): RequestResult<PublishModelDefinitionDraftResponses, PublishModelDefinitionDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishModelDefinitionDraftResponses, PublishModelDefinitionDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/drafts/{draftId}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the publish audit history for a model definition, newest first (admin only)
 */
export const getModelDefinitionPublishHistory = <ThrowOnError extends boolean = false>(options: Options<GetModelDefinitionPublishHistoryData, ThrowOnError>): RequestResult<GetModelDefinitionPublishHistoryResponses, GetModelDefinitionPublishHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetModelDefinitionPublishHistoryResponses, GetModelDefinitionPublishHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/{modelDefinitionId}/publish-history',
    ...options
});

/**
 * Export all published model definitions as a versioned JSON document (admin only)
 */
export const exportModelDefinitions = <ThrowOnError extends boolean = false>(options?: Options<ExportModelDefinitionsData, ThrowOnError>): RequestResult<ExportModelDefinitionsResponses, ExportModelDefinitionsErrors, ThrowOnError> => (options?.client ?? client).get<ExportModelDefinitionsResponses, ExportModelDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/export',
    ...options
});

/**
 * Import a versioned JSON document of model definitions as drafts (matching by stable source id, with name fallback for legacy hand-authored definitions). Definitions whose content already matches what is stored are skipped, so only genuine changes come back as drafts and re-importing the same document is a no-op. Imported data is never published automatically - each returned definition must still be reviewed and published (admin only)
 */
export const importModelDefinitions = <ThrowOnError extends boolean = false>(options: Options<ImportModelDefinitionsData, ThrowOnError>): RequestResult<ImportModelDefinitionsResponses, ImportModelDefinitionsErrors, ThrowOnError> => (options.client ?? client).post<ImportModelDefinitionsResponses, ImportModelDefinitionsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/model-definitions/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the paints the caller can use - the shared catalogue plus, when signed in, their own. This is what backs the paint picker on a recipe.
 */
export const getPaints = <ThrowOnError extends boolean = false>(options?: Options<GetPaintsData, ThrowOnError>): RequestResult<GetPaintsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPaintsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    url: '/api/v1/paints',
    ...options
});

/**
 * List the signed-in user's own paints
 *
 * Both kinds of personal paint: customisations of catalogue paints (which carry a basePaintId) and paints the user added themselves, such as a mix of their own or a brand the catalogue doesn't carry.
 */
export const getMyPaints = <ThrowOnError extends boolean = false>(options?: Options<GetMyPaintsData, ThrowOnError>): RequestResult<GetMyPaintsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyPaintsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints',
    ...options
});

/**
 * Add a paint of the user's own
 */
export const createMyPaint = <ThrowOnError extends boolean = false>(options: Options<CreateMyPaintData, ThrowOnError>): RequestResult<CreateMyPaintResponses, CreateMyPaintErrors, ThrowOnError> => (options.client ?? client).post<CreateMyPaintResponses, CreateMyPaintErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared paint catalogue on its own
 *
 * GET /api/v1/paints returns the shared catalogue and the user's own together. This endpoint returns the shared paints alone: to offer them for customisation, and to diff a personal copy against the paint it was forked from.
 */
export const getSharedPaints = <ThrowOnError extends boolean = false>(options?: Options<GetSharedPaintsData, ThrowOnError>): RequestResult<GetSharedPaintsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSharedPaintsResponses, unknown, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints/shared',
    ...options
});

/**
 * Delete one of the user's own paints
 *
 * For a customisation this is the "revert to the catalogue version" action.
 */
export const deleteMyPaint = <ThrowOnError extends boolean = false>(options: Options<DeleteMyPaintData, ThrowOnError>): RequestResult<DeleteMyPaintResponses, DeleteMyPaintErrors, ThrowOnError> => (options.client ?? client).delete<DeleteMyPaintResponses, DeleteMyPaintErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints/{paintId}',
    ...options
});

/**
 * Update one of the user's own paints
 */
export const updateMyPaint = <ThrowOnError extends boolean = false>(options: Options<UpdateMyPaintData, ThrowOnError>): RequestResult<UpdateMyPaintResponses, UpdateMyPaintErrors, ThrowOnError> => (options.client ?? client).put<UpdateMyPaintResponses, UpdateMyPaintErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints/{paintId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Start customising a shared paint
 *
 * Copies the catalogue paint into one owned by the caller, which they can then rename or recolour - useful when a paint has been reformulated, or the user thins or mixes it and wants their own swatch. Idempotent - returns the existing customisation if they already have one.
 */
export const customisePaint = <ThrowOnError extends boolean = false>(options: Options<CustomisePaintData, ThrowOnError>): RequestResult<CustomisePaintResponses, CustomisePaintErrors, ThrowOnError> => (options.client ?? client).post<CustomisePaintResponses, CustomisePaintErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/paints/from/{paintId}',
    ...options
});

/**
 * Hide or show definitions for the calling user
 *
 * A catalogue holds far more than any one person uses - a whole paint range, every faction in the game - so a user can take what they never reach for out of their own pickers.
 * This is a preference and not a permission. Nothing is deleted, no other user is affected, and a hidden definition already recorded against a model or a paint recipe carries on displaying: hiding only stops it being offered as a new choice.
 * Hiding a faction also takes its model definitions out of the model picker, because the reason to hide a faction is that you do not play it. Those models report hidden themselves, and show again as soon as the faction does.
 * Takes a set of ids so a user can clear a whole brand or faction at once, and is idempotent: hiding what is already hidden, or showing what was never hidden, changes nothing.
 */
export const setDefinitionsHidden = <ThrowOnError extends boolean = false>(options: Options<SetDefinitionsHiddenData, ThrowOnError>): RequestResult<SetDefinitionsHiddenResponses, SetDefinitionsHiddenErrors, ThrowOnError> => (options.client ?? client).put<SetDefinitionsHiddenResponses, SetDefinitionsHiddenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/my/hidden-definitions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the shared paint catalogue (admin only), each with how many recipes use it. Personal paints are never returned here.
 */
export const getAdminPaints = <ThrowOnError extends boolean = false>(options?: Options<GetAdminPaintsData, ThrowOnError>): RequestResult<GetAdminPaintsResponses, GetAdminPaintsErrors, ThrowOnError> => (options?.client ?? client).get<GetAdminPaintsResponses, GetAdminPaintsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints',
    ...options
});

/**
 * Add a paint to the shared catalogue (admin only)
 */
export const createPaint = <ThrowOnError extends boolean = false>(options: Options<CreatePaintData, ThrowOnError>): RequestResult<CreatePaintResponses, CreatePaintErrors, ThrowOnError> => (options.client ?? client).post<CreatePaintResponses, CreatePaintErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove a paint from the shared catalogue (admin only)
 */
export const deletePaint = <ThrowOnError extends boolean = false>(options: Options<DeletePaintData, ThrowOnError>): RequestResult<DeletePaintResponses, DeletePaintErrors, ThrowOnError> => (options.client ?? client).delete<DeletePaintResponses, DeletePaintErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/{paintId}',
    ...options
});

/**
 * Propose a change to a shared paint (admin only). The change is staged for review rather than applied, because one catalogue row backs every recipe that uses the paint. Proposing the state already stored instead clears any pending change and returns 204.
 */
export const proposePaintChange = <ThrowOnError extends boolean = false>(options: Options<ProposePaintChangeData, ThrowOnError>): RequestResult<ProposePaintChangeResponses, ProposePaintChangeErrors, ThrowOnError> => (options.client ?? client).patch<ProposePaintChangeResponses, ProposePaintChangeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/{paintId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List pending paint changes awaiting review (admin only), each showing the stored state and the state that would be applied.
 */
export const getPaintDrafts = <ThrowOnError extends boolean = false>(options?: Options<GetPaintDraftsData, ThrowOnError>): RequestResult<GetPaintDraftsResponses, GetPaintDraftsErrors, ThrowOnError> => (options?.client ?? client).get<GetPaintDraftsResponses, GetPaintDraftsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/drafts',
    ...options
});

/**
 * Accept a pending paint change (admin only), applying it to the shared catalogue and therefore to every recipe that uses the paint, and recording an audit entry.
 */
export const publishPaintDraft = <ThrowOnError extends boolean = false>(options: Options<PublishPaintDraftData, ThrowOnError>): RequestResult<PublishPaintDraftResponses, PublishPaintDraftErrors, ThrowOnError> => (options.client ?? client).post<PublishPaintDraftResponses, PublishPaintDraftErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/drafts/{draftId}/publish',
    ...options
});

/**
 * Reject a pending paint change (admin only), keeping the stored state.
 */
export const discardPaintDraft = <ThrowOnError extends boolean = false>(options: Options<DiscardPaintDraftData, ThrowOnError>): RequestResult<DiscardPaintDraftResponses, DiscardPaintDraftErrors, ThrowOnError> => (options.client ?? client).delete<DiscardPaintDraftResponses, DiscardPaintDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/drafts/{draftId}',
    ...options
});

/**
 * Accepted changes to this paint, most recent first (admin only)
 */
export const getPaintPublishHistory = <ThrowOnError extends boolean = false>(options: Options<GetPaintPublishHistoryData, ThrowOnError>): RequestResult<GetPaintPublishHistoryResponses, GetPaintPublishHistoryErrors, ThrowOnError> => (options.client ?? client).get<GetPaintPublishHistoryResponses, GetPaintPublishHistoryErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/{paintId}/publish-history',
    ...options
});

/**
 * Export the whole shared paint catalogue as a versioned JSON document (admin only), including paints no recipe currently uses.
 */
export const exportPaints = <ThrowOnError extends boolean = false>(options?: Options<ExportPaintsData, ThrowOnError>): RequestResult<ExportPaintsResponses, ExportPaintsErrors, ThrowOnError> => (options?.client ?? client).get<ExportPaintsResponses, ExportPaintsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/export',
    ...options
});

/**
 * Import a versioned JSON document of paints (admin only), matched by stable source id. Paints the catalogue does not have yet are created outright, but an entry differing from the stored one raises a pending change for review rather than being applied - one catalogue row backs every recipe that names the paint, in every user's collection, so an unattended edit fans out across all of them.
 */
export const importPaints = <ThrowOnError extends boolean = false>(options: Options<ImportPaintsData, ThrowOnError>): RequestResult<ImportPaintsResponses, ImportPaintsErrors, ThrowOnError> => (options.client ?? client).post<ImportPaintsResponses, ImportPaintsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/admin/paints/import',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Every paint recipe that applies anywhere in this collection
 *
 * Returns the collection-wide recipe, the recipes attached to a model type within this collection, and the recipes attached to individual models, in one call. A model's effective recipe is the collection one, then its type's, then its own, so the client can resolve what to show without a request per model.
 */
export const getPaintRecipes = <ThrowOnError extends boolean = false>(options: Options<GetPaintRecipesData, ThrowOnError>): RequestResult<GetPaintRecipesResponses, GetPaintRecipesErrors, ThrowOnError> => (options.client ?? client).get<GetPaintRecipesResponses, GetPaintRecipesErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/paint-recipes',
    ...options
});

/**
 * Create or replace the paint recipe at one scope
 *
 * Upserts by scope and target rather than by id, because at most one recipe exists per target. Sending an empty paint list and empty notes deletes the recipe instead, which is what clearing the editor does.
 */
export const savePaintRecipe = <ThrowOnError extends boolean = false>(options: Options<SavePaintRecipeData, ThrowOnError>): RequestResult<SavePaintRecipeResponses, SavePaintRecipeErrors, ThrowOnError> => (options.client ?? client).put<SavePaintRecipeResponses, SavePaintRecipeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/paint-recipes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all models in an army collection
 */
export const getCollectionModels = <ThrowOnError extends boolean = false>(options: Options<GetCollectionModelsData, ThrowOnError>): RequestResult<GetCollectionModelsResponses, GetCollectionModelsErrors, ThrowOnError> => (options.client ?? client).get<GetCollectionModelsResponses, GetCollectionModelsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/models',
    ...options
});

/**
 * Add a new model to an army collection
 */
export const createCollectionModel = <ThrowOnError extends boolean = false>(options: Options<CreateCollectionModelData, ThrowOnError>): RequestResult<CreateCollectionModelResponses, CreateCollectionModelErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectionModelResponses, CreateCollectionModelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/models',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Add many models of a single model definition to an army collection at once
 */
export const bulkCreateCollectionModels = <ThrowOnError extends boolean = false>(options: Options<BulkCreateCollectionModelsData, ThrowOnError>): RequestResult<BulkCreateCollectionModelsResponses, BulkCreateCollectionModelsErrors, ThrowOnError> => (options.client ?? client).post<BulkCreateCollectionModelsResponses, BulkCreateCollectionModelsErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/models/bulk',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a collection model (and its images)
 */
export const deleteCollectionModel = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionModelData, ThrowOnError>): RequestResult<DeleteCollectionModelResponses, DeleteCollectionModelErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectionModelResponses, DeleteCollectionModelErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}',
    ...options
});

/**
 * Rename/update a collection model
 */
export const updateCollectionModel = <ThrowOnError extends boolean = false>(options: Options<UpdateCollectionModelData, ThrowOnError>): RequestResult<UpdateCollectionModelResponses, UpdateCollectionModelErrors, ThrowOnError> => (options.client ?? client).patch<UpdateCollectionModelResponses, UpdateCollectionModelErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record a status the miniature entered on a chosen date
 *
 * Adds one historical transition: the status it moved to, and the calendar date that happened. There is no "before" status. The date is stored as 00:00 UTC. If that moment is the latest change, it also becomes the miniature's current status.
 */
export const recordCollectionModelStatusEvent = <ThrowOnError extends boolean = false>(options: Options<RecordCollectionModelStatusEventData, ThrowOnError>): RequestResult<RecordCollectionModelStatusEventResponses, RecordCollectionModelStatusEventErrors, ThrowOnError> => (options.client ?? client).post<RecordCollectionModelStatusEventResponses, RecordCollectionModelStatusEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/status-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove one status change from a miniature's history
 *
 * Refused when it is the only remaining change. If the removed change was the latest, the miniature's current status becomes the newest change that is left.
 */
export const deleteCollectionModelStatusEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionModelStatusEventData, ThrowOnError>): RequestResult<DeleteCollectionModelStatusEventResponses, DeleteCollectionModelStatusEventErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectionModelStatusEventResponses, DeleteCollectionModelStatusEventErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/status-events/{statusEventId}',
    ...options
});

/**
 * Delete many collection models (and their images) at once
 */
export const bulkDeleteCollectionModels = <ThrowOnError extends boolean = false>(options: Options<BulkDeleteCollectionModelsData, ThrowOnError>): RequestResult<BulkDeleteCollectionModelsResponses, BulkDeleteCollectionModelsErrors, ThrowOnError> => (options.client ?? client).post<BulkDeleteCollectionModelsResponses, BulkDeleteCollectionModelsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/army-collections/{armyCollectionId}/models/bulk-delete',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Preview what changing a collection model's definition would do to its wargear
 *
 * A read-only dry run. Nothing is persisted; the result describes how each existing wargear assignment would be remapped onto the target definition's slots.
 */
export const previewModelDefinitionChange = <ThrowOnError extends boolean = false>(options: Options<PreviewModelDefinitionChangeData, ThrowOnError>): RequestResult<PreviewModelDefinitionChangeResponses, PreviewModelDefinitionChangeErrors, ThrowOnError> => (options.client ?? client).post<PreviewModelDefinitionChangeResponses, PreviewModelDefinitionChangeErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/model-definition-change-preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request a presigned URL to upload a new image for a collection model
 */
export const createCollectionModelImageUploadUrl = <ThrowOnError extends boolean = false>(options: Options<CreateCollectionModelImageUploadUrlData, ThrowOnError>): RequestResult<CreateCollectionModelImageUploadUrlResponses, CreateCollectionModelImageUploadUrlErrors, ThrowOnError> => (options.client ?? client).post<CreateCollectionModelImageUploadUrlResponses, CreateCollectionModelImageUploadUrlErrors, ThrowOnError>({
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/images',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an image attached to a collection model
 */
export const deleteCollectionModelImage = <ThrowOnError extends boolean = false>(options: Options<DeleteCollectionModelImageData, ThrowOnError>): RequestResult<DeleteCollectionModelImageResponses, DeleteCollectionModelImageErrors, ThrowOnError> => (options.client ?? client).delete<DeleteCollectionModelImageResponses, DeleteCollectionModelImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/images/{imageId}',
    ...options
});

/**
 * Choose which photo is shown for this miniature in the collection list
 */
export const setCollectionModelListThumbnail = <ThrowOnError extends boolean = false>(options: Options<SetCollectionModelListThumbnailData, ThrowOnError>): RequestResult<SetCollectionModelListThumbnailResponses, SetCollectionModelListThumbnailErrors, ThrowOnError> => (options.client ?? client).put<SetCollectionModelListThumbnailResponses, SetCollectionModelListThumbnailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/v1/collection-models/{collectionModelId}/images/{imageId}/list-thumbnail',
    ...options
});
